import {createAsyncThunk} from '@reduxjs/toolkit'
import AxiosClient from '../AxiosClient'

// First page table Data
export const getOptionAttributeMappingList = createAsyncThunk(
  'product/getOptionAttributeMappingList',
  async function (params:{platformId: number, skip?: number, limit?: number}, toolkit) {
    const skip = params?.skip ?? 0
    const limit = params?.limit ?? 5
    return await AxiosClient(
      'GET',
      `/api/platform-option-attribute-mapped-value?platform_id=${params?.platformId}&skip=${skip}&limit=${limit}`,
      params,
      toolkit,
      []
    )
  }
)

//GET Option Attribute Mapping Data for EDIT
export const getOptionAttributeMappingById = createAsyncThunk(
  'product/getOptionAttributeMappingById ',
  async function (params:{platformId: number, id: number}, toolkit) {
    return await AxiosClient(
      'GET',
      `/api/platform-option-attribute-mapped-value/${params?.id}?platform_id=${params?.platformId}`,
      params,
      toolkit,
      []
    )
  }
)

// Get Select-Option Data on the Create new Mapping Modal First Dropdown
export const getOptionsForAttributeMapping = createAsyncThunk(
  'product/getOptionsForAttributeMapping ',
  async function (params:{platformId: number, searchTerm?: string, skip?: number}, toolkit) {
    const skip = params?.skip ?? 0
    return await AxiosClient(
      'GET',
      `/api/platform-option-attribute/${params?.platformId}?skip=${skip}`,
      params,
      toolkit,
      []
    )
  }
)


export const getOptionsAttributeMappingForSelectedId = createAsyncThunk(
  'product/getOptionsAttributeMappingForSelectedId ',
  async function (
    params:{
      platformId: number,
      attribute_template_id: number,
      search?:string,
      skip_field_data: number,
      skip_attribute_data?: number
    },
    toolkit
  ) {
    const skipAttributeData = params?.skip_attribute_data ?? 0
    return await AxiosClient(
      'GET',
      `/api/platform-option-attribute-value?attribute_template_id=${params.attribute_template_id}&platform_id=${params.platformId}&category_attribute_data_name=${params.search}&skip_field_data=${params.skip_field_data}&skip_attribute_data=${skipAttributeData}`,
      params,
      toolkit,
      []
    )
  }
)

export const saveOptionsAttributeMapping = createAsyncThunk(
  'product/getOptionsAttributeMappingForSelectedId ',
  async function (payload:any, toolkit) {
    return await AxiosClient(
      'POST',
      `/api/platform-option-attribute-value`,
      payload,
      toolkit,
      []
    )
  }
)

export const editOptionsAttributeMapping = createAsyncThunk(
  'product/editOptionsAttributeMapping ',
  async function (payload:any, toolkit) {
    return await AxiosClient(
      'PUT',
      `/api/platform-option-attribute-value/${payload.editId}`,
      payload,
      toolkit,
      []
    )
  }
)

export const deleteOptionsAttributeMapping = createAsyncThunk(
  'product/deleteOptionsAttributeMapping ',
  async function (payload:{platform_attribute_option_template_id: number}, toolkit) {
    return await AxiosClient(
      'DELETE',
      `/api/platform-option-attribute-value?platform_attribute_option_template_id=${payload?.platform_attribute_option_template_id}`,
      [],
      toolkit,
      []
    )
  }
)


export const deleteMapValuesMapping = createAsyncThunk(
  'product/deleteMapValuesMapping ',
  async function (payload:{platform_attribute_option_data_mapping_id: number|null}, toolkit) {
    return await AxiosClient(
      'DELETE',
      `/api/platform-option-attribute-value?platform_attribute_option_data_mapping_id=${payload?.platform_attribute_option_data_mapping_id}`,
      [],
      toolkit,
      []
    )
  }
)
